export const GROUP_GET_DATA = 'GROUP_GET_DATA';
export const GROUP_POST_DATA = 'GROUP_POST_DATA';
export const GROUP_UPDATE_DATA = 'GROUP_UPDATE_DATA';
export const GROUP_DELETE_DATA = 'GROUP_DELETE_DATA';
export const GROUP_SUCCESS_DATA = 'GROUP_SUCCESS_DATA';
export const GROUP_LOADING_DATA = 'GROUP_LOADING_DATA';
export const GROUP_FAILED_DATA = 'GROUP_FAILED_DATA';
export const RECENT_MESSAGE_DATA = 'RECENT_MESSAGE_DATA';
export const GROUP_INVITE_GEN_SUCCESS = 'GROUP_INVITE_GEN_SUCCESS';
export const GROUP_INVITE_GEN_FAILED = 'GROUP_INVITE_GEN_FAILED';
export const GROUP_INVITE_SAVE = 'GROUP_INVITE_SAVE';
export const GROUP_PROGRESS_ACCEPTED = 'GROUP_PROGRESS_ACCEPTED';
export const GROUP_PROGRESS_DECLINED = 'GROUP_PROGRESS_DECLINED';